import {useEffect} from "react";
import {useTranslation} from "react-i18next";

import {toaster} from "../../utilities/hooks/toaster";

export default function SilentErrorListener() {
  const {t} = useTranslation();
  const autoClose = 3000;

  useEffect(() => {
    const handleGlobalError = event => {
      event.preventDefault();

      const errorMessage = event.error?.message || event.message || t("Сталася помилка при завантаженні даних");

      toaster.error(`${t("An error happened")}: ${errorMessage}`, autoClose);
      console.error(event.error);
    };

    // Перехват упавших Promise (fetch, axios, Redux thunks)
    const handleUnhandledRejection = event => {
      event.preventDefault();

      const reason = event.reason?.message || t("Server request error happened");
      toaster.error(`${t("Background mistake happened")}: ${reason}`, autoClose);
    };

    window.addEventListener("error", handleGlobalError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("error", handleGlobalError);
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
    };
  }, []);

  return null;
}
